export default __webpack_public_path__ + "static/media/Upload.e79fc8f6.svg";